import React, { useEffect } from "react";
import { format } from "date-fns";

type IProp = {
    list: {
        headers: string[];
        data: Record<string, any>[];
    };
    fileNamePrefix?: string; // Optional prefix for the file name
    onExportComplete: () => void;
};

const escapeCsvValue = (value: any) => {
    if (value === null || value === undefined) return "";
    const stringValue = String(value);

    if (stringValue.includes('"') || stringValue.includes(',')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
};

// Generate CSV Data
const generateCSVData = (leadList: { headers: string[]; data: Record<string, any>[] } | null): string => {
    if (!leadList || !leadList.data.length) return "";

    const rows: string[] = [];
    rows.push(leadList.headers.map(escapeCsvValue).join(",")); // Add headers

    leadList.data.forEach((row) => {
        rows.push(leadList.headers.map((header) => escapeCsvValue(row[header])).join(",")); // Add data rows
    });

    return rows.join("\n");
};

// Function to Trigger CSV Download
const exportToCSV = (filename: string, data: string) => {
    const blob = new Blob([data], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

const CSVExport: React.FC<IProp> = ({ list, fileNamePrefix, onExportComplete }) => {

    useEffect(() => {
        if (!list || !list.data.length) {
            onExportComplete();
            return;
        }

        const prefix = fileNamePrefix ? `${fileNamePrefix}_` : "Export_";   
        const fileName = `${prefix}_${format(new Date(), "MMddyyyyHHmmss")}.csv`;
        const csvData = generateCSVData(list);
        exportToCSV(fileName, csvData);

        onExportComplete(); 
    }, [list, onExportComplete]); 

    return null; 
};

export default CSVExport;
